import type {ExpressionElement} from '@packages/systems/wfdl-ast';
import type {UniqueIdsState} from '@packages/utilities/platform-instantiateExpressionWithUniqueIds';
import type {Component} from '@packages/systems/wfdl';
import {refreshElementIds} from './refreshElementIds';

/**
 * Given an element, returns a deep copy of the element and
 * the ids being used.
 */
export function cloneElementWithIdMapping(
  element: ExpressionElement,
  componentMap: Component.ComponentMap,
  seedId: string
): {
  idsState: UniqueIdsState;
  clonedElement: ExpressionElement;
} {
  const {idsState, refreshedElement} = refreshElementIds(element, seedId);
  return {idsState, clonedElement: refreshedElement};
}

/**
 * Given an element, returns a deep copy of the element
 */
export function cloneElement(
  element: ExpressionElement,
  componentMap: Component.ComponentMap,
  seedId: string
): ExpressionElement {
  return cloneElementWithIdMapping(element, componentMap, seedId).clonedElement;
}
